import React from 'react'
import PropTypes from 'prop-types'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import InitiativeListDeprecate from 'src/components/Initiative/ListDeprecate'
import { useOrganization } from 'src/graphql/hooks'
import { OrganizationPropType } from 'src/libraries/propTypes'

// =======================================================
// Layout
// =======================================================

const ExploreHomeLayout1 = ({ initiativesGroupedByType }) => {
   const { organization } = useOrganization()

   // TODO: This should come from ThemeProvider instead
   const highlightColor = organization.theme.highlightColor || '#5e48e6'

   return (
      <>
         {initiativesGroupedByType.map(initiativeType => (
            <View
               key={initiativeType.id}
               float="left"
               width="100%"
               marginBottom="30px">
               <View margin="0px 0px 12px 0px">
                  <View
                     display="flex"
                     alignItems="center"
                     justifyContent="space-between"
                     paddingRight="12px">
                     <Text color="#000" size="3[a-b] 5[c] 5[d] 5[e-f]" weight="medium">
                        {`Latest ${initiativeType.namePlural}`}
                     </Text>
                     <Link to={`/explore/${initiativeType.slug}`}>
                        <Text size="2" color={highlightColor} weight="medium">
                           <u>See All</u>
                        </Text>
                     </Link>
                  </View>
                  <View display="none[a-b] block[c-f]" margin="0px 0px 18px 0px">
                     <Text color="#666" size="2[a-d] 3[e-f]" lineHeight="140%">
                        {initiativeType.description}
                     </Text>
                  </View>
               </View>
               <InitiativeListDeprecate
                  cardFormat="carousel"
                  initiativeType={initiativeType}
               />
            </View>
         ))}
      </>
   )
}

ExploreHomeLayout1.propTypes = {
   initiativesGroupedByType: PropTypes.arrayOf(
      PropTypes.shape({
         ...OrganizationPropType.initiativeTypes,
         initiatives: PropTypes.array.isRequired
      }).isRequired
   ).isRequired
}

export default ExploreHomeLayout1
